// Le signalement d'un problème : le texte du joueur part vers le petit service du jeu
// (voir serveur/compteur-vies/), sans adresse mail ni identité. Rien n'est envoyé sans son clic.
import { COUNTER_URL } from './compteur';

export interface BugContext {
  version: string;
  partie: string;
  navigateur: string;
}

/** Envoie le signalement ; renvoie faux si le service est injoignable (le mail reste en secours). */
export async function sendBugReport(texte: string, contexte: BugContext): Promise<boolean> {
  if (!COUNTER_URL || typeof document === 'undefined') return false;
  try {
    const response = await fetch(`${COUNTER_URL}/signalement`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ texte, ...contexte }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
